import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bed"
const BedIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.5 3.75a1.5 1.5 0 0 1 1.5 1.5v6.201c.448.26.75.744.75 1.299v7.5h-1.5V18H3.75v2.25h-1.5v-7.5c0-.555.302-1.04.75-1.299V5.25a1.5 1.5 0 0 1 1.5-1.5zM6 8.813c-.932 0-1.687.755-1.687 1.687v.75c0 .104.083.188.187.188h6.75a.187.187 0 0 0 .188-.188v-.75c0-.932-.756-1.687-1.688-1.687zm8.25 0c-.932 0-1.687.755-1.687 1.687v.75c0 .104.083.188.187.188h6.75a.187.187 0 0 0 .188-.188v-.75c0-.932-.756-1.687-1.688-1.687z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BedIcon
